import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const propTypes = {
  img: PropTypes.string.isRequired,
  resizeInterval: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.any,
  onLoadFunction: PropTypes.func,
};

const defaultProps = {
  resizeInterval: 128,
  onLoadFunction: () => {},
};

class SnapshotBackground extends React.Component {

  constructor(props) {
    super(props);
    this.state = {currentIndex: 0, images: null};
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
  }

  componentWillMount() {
    this.setUpImages(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.images) {
      this.setUpImages(nextProps);
    } else if (this.props.img !== nextProps.img) {
      let nextIndex = Number(!this.state.currentIndex);
      let images = this.state.images;
      images[nextIndex] = nextProps.img;
      this.setState({images, currentIndex: nextIndex});
      this.timeout = setTimeout(this.handleImageLoaded, 3000);
    }
  }

  setUpImages(props) {
    let images = [];
    if(_.isEmpty(props.img)) return;
    for(var i = 0; i < 2; i++) {
      images[i] = props.img;
    }
    this.setState({images});
  }

  setImagesVisibility() {
    let topCanvas = this.refs.image1;
    if(this.state.currentIndex === 0) {
      topCanvas.className = 'snapshot-background-canvas top-canvas';
    }else {
      topCanvas.className = 'snapshot-background-canvas top-canvas transparent';
    }
  }

  handleImageLoaded(event) {
    this.setImagesVisibility();
    this.props.onLoadFunction(event);
    clearTimeout(this.timeout);
  }

  render() {
    var { className, children } = this.props;
    let { images } = this.state;
    var classes = 'snapshot-background';

    if (className) {
      classes += ' ' + className;
    }
    if(!images) return null;

    return (
      <div className={classes}>
        <img src={images[0]} onLoad={this.handleImageLoaded}  className='snapshot-background-canvas top-canvas' ref='image1'/>
        <img src={images[1]} onLoad={this.handleImageLoaded} className='snapshot-background-canvas' ref='image2'/>
        {children}
      </div>
    );
  }

}

SnapshotBackground.propTypes = propTypes;
SnapshotBackground.defaultProps = defaultProps;

export default SnapshotBackground;
